/**
 * Selection rule for a tapped event-log row.
 *
 * A log row opens the time machine at that event. Tapping the row that is
 * ALREADY open closes it and returns to live — the same tap that opened the
 * snapshot closes it, so a log row behaves like every other toggle in the app
 * instead of being a one-way door out of live play.
 *
 * Lives here rather than inline in the game screen's `setState` callback so
 * the rule is stated once and can be tested without mounting the screen.
 *
 * Deliberately NOT used by the overlay's auto-select-newest effect: that sets
 * an index in response to new data arriving, not to a tap, and must never
 * toggle a row off underneath the user.
 */
export function toggleEventSelection(
  current: number | null,
  tapped: number,
): number | null {
  return current === tapped ? null : tapped
}
